import {LogoPoolEntry} from "./databaseInterfaceClasses";

const addPNGExtension = s=>s+".png";

function getStockLogoSubDirFromID(id:string) {
    return toStringWithToDigits(parseInt(id)%100);
}


export function toStringWithToDigits(num) {
    return num < 10 ? "0"+num.toString() : num.toString();
}


export interface ILogoPoolStore {
    addLogos(newLogos);
    getAddedLogos :(logosToTest:LogoPoolEntry[])=>LogoPoolEntry[];
    getDeletedLogos : (logosToTest:LogoPoolEntry[])=>LogoPoolEntry[];
    getLogos : ()=>LogoPoolEntry[];
    logoPoolIsEmtpy : ()=>boolean;
    removeLogosFromLogoPool: (deletedLogos:LogoPoolEntry[])=>void
    getLogoByFilename : (filename)=>LogoPoolEntry|null;
    getLogoById:(id:string)=>LogoPoolEntry|null;
    removeLogo :(logoPoolEntry: LogoPoolEntry)=>void;
    removeStockLogo : (logoPoolEntry:LogoPoolEntry)=>void;
    setLogos:(logos: LogoPoolEntry[])=>void
    getLogoByTypeAndFilename:(type, filename)=>LogoPoolEntry|null
    loadLogoPool()
}
